import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {withStyles} from "@material-ui/styles";
import Risk from "./Risk";
import Legal from "./Legal";
import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import {CardContent} from "@material-ui/core";

const classes = () => ({
    card: {
        width: '100%',
    },
});

class Planning extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { classes } = this.props;

        return <div>
            <div className="mui-container-fluid">
                <Route path={`/planning` }>
                    <Paper>
                        <Card className={classes.card}>
                            <CardContent>
                                <Route
                                    path={`/planning/risk`}
                                    render={() =>
                                        <Risk currentUser={this.props.currentUser}/>
                                    }
                                />
                                <Route path={`/planning/legal-requirements`}
                                render={() =>
                                    <Legal currentUser={this.props.currentUser}/>
                                }/>
                            </CardContent>
                        </Card>
                    </Paper>
                </Route>
            </div>
        </div>;
    }
}

export default withStyles(classes)(Planning);